// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {MultiSelect} from '@deere/isg.component-library';

function OnLinkDialogNavMobile(props) {
    const {
        activeTab,
        content,
        navButton,
        onTabClick
    } = props;

    const displayableItems = content.filter((item) => item.title);

    let footerAction = null;

    if (navButton) {
        const {
            children, onClick
        } = navButton.props;

        footerAction = {
            title: children,
            onClick
        };
    }

    return (
        <MultiSelect
            disableSorting={true}
            footerAction={footerAction}
            fullWidth
            items={displayableItems}
            labels={{
                multiSelect: 'MultiSelect',
                placeholder: '',
                emptyList: ''
            }}
            noSearch={true}
            onChange={([tabId]) => {
                onTabClick(tabId);
            }}
            selectedIds={[activeTab]}
            single
        />
    );
}

OnLinkDialogNavMobile.propTypes = {
    activeTab: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.dialogContent),
    navButton: PropTypes.element,
    onTabClick: PropTypes.func
};

export default OnLinkDialogNavMobile;
